import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactoModalComponent } from '../modal/contacto-modal/contacto-modal.component';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup } from '@angular/forms';
import { PageService } from '../services/page.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.css'],
})
export class ContactosComponent implements OnInit, AfterViewInit {
  contactos: any;
  spinner = false;
  tipo: string;
  public searchForm: FormGroup;
  originalContactos: any[];
  cargosList: any[];
  codigoColaborador: any;

  columns: string[] = [
    'nombreContacto',
    'apellido1Contacto',
    'apellido2Contacto',
    'correoContacto',
    'telefonoContacto',
    'cargoContacto',
    'acciones',
  ];

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private dialog: MatDialog,
    private service: PageService,
    private router: Router
  ) {
    this.codigoColaborador = sessionStorage.getItem('codigoColaborador');
  }

  async ngOnInit(): Promise<void> {
    this.contactos = new MatTableDataSource();
    console.log(this.codigoColaborador);
    this.service.getCargos().subscribe((res) => {
      console.log(res);
      this.cargosList = res;
    });
    this.service
      .getContactosByColaborador(this.codigoColaborador)
      .subscribe((res) => {
        console.log(res);
        const seen = new Set();
        this.originalContactos = res.filter((contacto) => {
          if (seen.has(contacto.id)) {
            return false;
          }
          seen.add(contacto.id);
          return true;
        });
        this.contactos.data = [...this.originalContactos];
      });
    this.searchFormInit();
    console.log(this.contactos);
  }

  ngAfterViewInit(): void {
    this.contactos.sort = this.sort;
  }

  searchFormInit(): void {
    this.searchForm = new FormGroup({
      nombre: new FormControl(''),
      apellido1: new FormControl(''),
      correo: new FormControl(''),
      cargo: new FormControl(''),
    });
  }

  abrirModalContacto(element?: any, cargosList?: any) {
    console.log("element:",element);
    if (element && element.id) {
      this.tipo = 'Editar';
    } else {
      this.tipo = 'Crear';
    }
    const dialogRef = this.dialog.open(ContactoModalComponent, {
      width: '60%',
      data: {
        tipo: this.tipo,
        contacto: element,
        cargosList: cargosList,
      },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('Cierro', result);
      this.router.navigate(['page/contactos']);
    });
  }

  applyFilter(): void {
    const filtro = this.searchForm.value;
    const filtroVacio = Object.values(filtro).every(
      (value) => value === '' || value === null
    );
    let filteredData = this.originalContactos;

    if (!filtroVacio) {
      filteredData = this.originalContactos.filter((contacto) => {
        const nombre = filtro.nombre.trim().toUpperCase();
        const apellido1 = filtro.apellido1.trim().toUpperCase();
        const correo = filtro.correo.trim().toUpperCase();
        const cargo = filtro.cargo.trim().toUpperCase();

        return (
          (nombre === '' ||
            contacto.nombreContacto.toUpperCase().includes(nombre)) &&
          (apellido1 === '' ||
            contacto.apellido1Contacto.toUpperCase().includes(apellido1)) &&
          (correo === '' ||
            contacto.correoContacto.toUpperCase().includes(correo)) &&
          (cargo === '' || contacto.cargoContacto.toUpperCase().includes(cargo))
        );
      });
    }

    this.contactos.data = filteredData;
  }
}
